import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Footer from "@/components/site/Footer";

export default function Datenschutz() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div
            data-testid="datenschutz-page"
            className="bg-background text-foreground min-h-screen"
        >
            <header className="border-b border-border/60">
                <div className="container-em py-6 flex items-center justify-between">
                    <Link
                        to="/"
                        data-testid="datenschutz-back-link"
                        className="inline-flex items-center gap-2 text-foreground/70 hover:text-foreground transition-colors"
                    >
                        <ArrowLeft size={16} /> Zur Startseite
                    </Link>
                    <span className="font-display text-2xl tracking-tight">
                        Emsglück<span className="text-primary">.</span>
                    </span>
                </div>
            </header>

            <main className="container-em py-16 md:py-24 max-w-3xl">
                <span className="font-accent text-xs uppercase tracking-[0.3em] text-primary">
                    Rechtliches
                </span>
                <h1 className="mt-4 font-display text-4xl md:text-5xl leading-tight tracking-tight">
                    Datenschutzerklärung
                </h1>

                <div className="mt-12 space-y-10 text-foreground/85 leading-relaxed">
                    <section>
                        <h2 className="font-display text-2xl text-foreground">
                            1. Verantwortliche Stelle
                        </h2>
                        <p className="mt-4">
                            Verantwortlich für die Datenverarbeitung auf dieser
                            Website ist:
                        </p>
                        <address className="mt-3 not-italic">
                            Jennifer Freimuth-Kröger
                            <br />
                            Wabenweg 31A
                            <br />
                            26125 Oldenburg
                            <br />
                            E-Mail:{" "}
                            <a
                                href="mailto:info@emsglueck.com"
                                className="text-primary hover:underline"
                            >
                                info@emsglueck.com
                            </a>
                        </address>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl text-foreground">
                            2. Allgemeine Hinweise
                        </h2>
                        <p className="mt-4">
                            Der Schutz Ihrer persönlichen Daten ist uns ein
                            wichtiges Anliegen. Wir behandeln Ihre
                            personenbezogenen Daten vertraulich und
                            entsprechend der gesetzlichen Datenschutzvorschriften
                            (insbesondere DSGVO, BDSG) sowie dieser
                            Datenschutzerklärung.
                        </p>
                        <p className="mt-3">
                            Bei der Nutzung dieser Website werden verschiedene
                            personenbezogene Daten erhoben. Personenbezogene
                            Daten sind Daten, mit denen Sie persönlich
                            identifiziert werden können. Die vorliegende
                            Datenschutzerklärung erläutert, welche Daten wir
                            erheben und wofür wir sie nutzen.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl text-foreground">
                            3. Zugriffsdaten / Server-Logfiles
                        </h2>
                        <p className="mt-4">
                            Beim Aufruf unserer Website werden durch den
                            Hosting-Anbieter automatisch technische
                            Zugriffsdaten in Server-Logfiles erfasst
                            (IP-Adresse, Datum, Uhrzeit, aufgerufene Seite,
                            Browser, Betriebssystem, Referrer-URL). Diese
                            Verarbeitung erfolgt zur Sicherstellung eines
                            störungsfreien Betriebs sowie zur Verbesserung
                            unseres Angebots. Rechtsgrundlage ist Art. 6 Abs. 1
                            lit. f DSGVO (berechtigtes Interesse). Diese Daten
                            werden nicht mit anderen Datenquellen
                            zusammengeführt.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl text-foreground">
                            4. Kontakt- und Buchungsanfrageformular
                        </h2>
                        <p className="mt-4">
                            Wenn Sie uns per Kontaktformular Anfragen zukommen
                            lassen, werden Ihre Angaben aus dem Formular
                            inklusive der von Ihnen dort angegebenen
                            Kontaktdaten (Name, E-Mail-Adresse, optional
                            Telefonnummer, Anreise- und Abreisedatum,
                            Personenanzahl, Anlass, Nachricht) zwecks
                            Bearbeitung der Anfrage und für den Fall von
                            Anschlussfragen bei uns gespeichert.
                        </p>
                        <p className="mt-3">
                            <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1
                            lit. b DSGVO (Anbahnung eines Vertragsverhältnisses)
                            sowie Art. 6 Abs. 1 lit. a DSGVO (Einwilligung, die
                            Sie durch Setzen des entsprechenden Häkchens
                            erteilen).
                        </p>
                        <p className="mt-3">
                            <strong>Speicherdauer:</strong> Die Daten werden
                            gelöscht, sobald sie für die Bearbeitung Ihrer
                            Anfrage nicht mehr erforderlich sind – in der Regel
                            spätestens sechs Monate nach der letzten
                            Kommunikation. Kommt es zu einem Buchungsvertrag,
                            gelten die gesetzlichen Aufbewahrungsfristen.
                        </p>
                        <p className="mt-3">
                            <strong>Empfänger:</strong> Ihre Angaben werden per
                            E-Mail über den Dienstleister Resend an unsere
                            Postfachadresse info@emsglueck.com übertragen
                            (siehe Punkt 5) und in einer verschlüsselten
                            Datenbank gespeichert. Eine Weitergabe an weitere
                            Dritte findet nicht statt.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl text-foreground">
                            5. Auftragsverarbeiter: Resend (E-Mail-Versand)
                        </h2>
                        <p className="mt-4">
                            Für den Versand transaktionaler E-Mails (z. B.
                            Weiterleitung Ihrer Anfrage an unser Postfach)
                            nutzen wir den Dienst Resend der Anbieterin{" "}
                            <em>Resend, Inc.</em>, 2261 Market Street #5039,
                            San Francisco, CA 94114, USA. Der Versand erfolgt
                            über die EU-Infrastruktur von Resend (Region
                            eu-west-1, Irland). Es besteht ein
                            Auftragsverarbeitungsvertrag (AVV) gemäß Art. 28
                            DSGVO. Soweit eine Datenübermittlung an die
                            US-Muttergesellschaft stattfindet, erfolgt diese
                            auf Grundlage der Standardvertragsklauseln der
                            EU-Kommission bzw. des EU-US Data Privacy
                            Framework. Details unter{" "}
                            <a
                                href="https://resend.com/legal/privacy-policy"
                                target="_blank"
                                rel="noreferrer"
                                className="text-primary hover:underline"
                            >
                                resend.com/legal/privacy-policy
                            </a>
                            .
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl text-foreground">
                            6. Hosting
                        </h2>
                        <p className="mt-4">
                            Diese Website wird auf Servern eines externen
                            Dienstleisters gehostet. Der Anbieter verarbeitet
                            technische Zugriffsdaten (siehe Punkt 3) im Auftrag
                            auf Basis eines Auftragsverarbeitungsvertrags nach
                            Art. 28 DSGVO. Serverstandort ist die EU.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl text-foreground">
                            7. Kartendarstellung (Google Maps)
                        </h2>
                        <p className="mt-4">
                            Auf unserer Website binden wir eine Karte des
                            Dienstes Google Maps der Google Ireland Ltd.
                            (Gordon House, Barrow Street, Dublin 4, Irland) via
                            iFrame ein, um Ihnen die Lage unserer Wohnung
                            anzuzeigen. Beim Aufruf der Seite werden dabei
                            Verbindungsdaten (u. a. IP-Adresse) an Google
                            übertragen. Rechtsgrundlage ist Art. 6 Abs. 1
                            lit. f DSGVO (berechtigtes Interesse an einer
                            ansprechenden Darstellung der Anfahrtsinformation).
                            Weitere Informationen finden Sie in der
                            Datenschutzerklärung von Google:{" "}
                            <a
                                href="https://policies.google.com/privacy"
                                target="_blank"
                                rel="noreferrer"
                                className="text-primary hover:underline"
                            >
                                policies.google.com/privacy
                            </a>
                            .
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl text-foreground">
                            8. Cookies
                        </h2>
                        <p className="mt-4">
                            Unsere Website setzt keine eigenen Marketing- oder
                            Tracking-Cookies ein. Es werden lediglich technisch
                            notwendige Session-Informationen im lokalen
                            Speicher Ihres Browsers abgelegt, sofern dies für
                            die Anzeige der Seite erforderlich ist. Eine
                            Einwilligung ist hierfür gemäß § 25 Abs. 2 Nr. 2
                            TTDSG nicht erforderlich.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl text-foreground">
                            9. Ihre Rechte
                        </h2>
                        <p className="mt-4">
                            Sie haben jederzeit das Recht auf unentgeltliche
                            Auskunft über Ihre gespeicherten personenbezogenen
                            Daten, deren Herkunft und Empfänger sowie den Zweck
                            der Datenverarbeitung (Art. 15 DSGVO). Zudem haben
                            Sie ein Recht auf Berichtigung (Art. 16), Löschung
                            (Art. 17), Einschränkung der Verarbeitung (Art. 18)
                            und Datenübertragbarkeit (Art. 20) sowie ein
                            Widerspruchsrecht gegen die Verarbeitung nach
                            Art. 21 DSGVO.
                        </p>
                        <p className="mt-3">
                            Eine erteilte Einwilligung können Sie jederzeit mit
                            Wirkung für die Zukunft widerrufen – eine formlose
                            Mitteilung per E-Mail an{" "}
                            <a
                                href="mailto:info@emsglueck.com"
                                className="text-primary hover:underline"
                            >
                                info@emsglueck.com
                            </a>{" "}
                            genügt.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl text-foreground">
                            10. Beschwerderecht bei der Aufsichtsbehörde
                        </h2>
                        <p className="mt-4">
                            Unbeschadet anderweitiger verwaltungsrechtlicher
                            oder gerichtlicher Rechtsbehelfe steht Ihnen ein
                            Beschwerderecht bei einer Datenschutz-Aufsichtsbehörde
                            zu, insbesondere in dem Mitgliedstaat Ihres
                            gewöhnlichen Aufenthaltsorts. Zuständig für uns ist
                            die Landesbeauftragte für den Datenschutz
                            Niedersachsen.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl text-foreground">
                            11. SSL-/TLS-Verschlüsselung
                        </h2>
                        <p className="mt-4">
                            Diese Website nutzt aus Sicherheitsgründen eine
                            SSL-/TLS-Verschlüsselung. Eine verschlüsselte
                            Verbindung erkennen Sie an der Adresszeile Ihres
                            Browsers (https:// statt http://).
                        </p>
                    </section>

                    <section>
                        <p className="text-sm text-foreground/60">
                            Stand: Januar 2026
                        </p>
                    </section>
                </div>
            </main>

            <Footer />
        </div>
    );
}
